// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const barrelStack = defineModel({
  id: "barrel-stack",
  batchId: "future",
  name: "Barrel stack",
  tags: ["scenery","barrel","stack","low-poly","age-of-mcp","future"],
  summary: "Stacked barrels — the container for every liquid and bulk dry good.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.44,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.18, 9), color: "#7a5126", position: [-0.24, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [-0.24, 0.0396, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [-0.24, 0.1404, 0] },
      { geometry: new THREE.CylinderGeometry(0.0962, 0.0962, 0.02, 9), color: "#8a5e30", position: [-0.24, 0.18, 0] },
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.18, 9), color: "#6b4621", position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0, 0.0396, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0, 0.1404, 0] },
      { geometry: new THREE.CylinderGeometry(0.0962, 0.0962, 0.02, 9), color: "#8a5e30", position: [0, 0.18, 0] },
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.18, 9), color: "#7a5126", position: [0.24, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0.24, 0.0396, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0.24, 0.1404, 0] },
      { geometry: new THREE.CylinderGeometry(0.0962, 0.0962, 0.02, 9), color: "#8a5e30", position: [0.24, 0.18, 0] },
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.18, 9), color: "#6b4621", position: [-0.12, 0.2448, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [-0.12, 0.1944, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [-0.12, 0.2952, 0] },
      { geometry: new THREE.CylinderGeometry(0.0962, 0.0962, 0.02, 9), color: "#8a5e30", position: [-0.12, 0.3348, 0] },
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.18, 9), color: "#7a5126", position: [0.12, 0.2448, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0.12, 0.1944, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0.12, 0.2952, 0] },
      { geometry: new THREE.CylinderGeometry(0.0962, 0.0962, 0.02, 9), color: "#8a5e30", position: [0.12, 0.3348, 0] },
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.18, 9), color: "#6b4621", position: [0, 0.3996, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0, 0.3492, 0] },
      { geometry: new THREE.CylinderGeometry(0.117, 0.117, 0.022, 9), color: "#42301c", position: [0, 0.45, 0] },
      { geometry: new THREE.CylinderGeometry(0.0962, 0.0962, 0.02, 9), color: "#8a5e30", position: [0, 0.4896, 0] },
    ],
  animations: [],
});
